import React from 'react';
import { IOrderBy, TSortOrder } from '@src/models/api';
import { useList, useUnit } from 'effector-react';
import { $tableStore } from '../store';
import { DataTableHeadCell } from '../_HeadCell/DataTableHeadCell';
import { $columnsStore } from '../store/columns';
import { useRowWidthStyles } from '../hooks';
import { DATA_ELEM_HEAD } from '../consts';

import styles from './DataTableHeadRow.module.scss';
import { IDataTableRequiredView } from '@src/molecules/DataTable/models';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';

interface IProps extends IDataTableRequiredView {}

const getSortOrder = (ordering: IOrderBy[], fieldId: string): TSortOrder | undefined => {
  for (const orderBy of ordering) {
    if (orderBy.field === fieldId) {
      return orderBy.sortOrder as TSortOrder;
    }
  }
};

export const DataTableHeadRow = ({ view }: IProps) => {
  const [tableStore] = useUnit([$tableStore]);
  const rowStyles = useRowWidthStyles();
  const wrapperClasses = classnames(styles.root, ...getClasses(styles, { view }));
  const { ordering = [] } = tableStore;
  const columns = useList($columnsStore, {
    keys: [ordering],
    fn: (column) => (
      <DataTableHeadCell key={column.id} column={column} sortOrder={getSortOrder(ordering, column.id)} view={view} />
    ),
  });

  return (
    <div className={wrapperClasses} style={rowStyles} data-elem={DATA_ELEM_HEAD}>
      {columns}
    </div>
  );
};
